import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/About.css';


const leadership = [
  ['Президент', 'Федоров Игорь Валерьевич'],
  ['Вице-президент', 'Маркова Александра'],
  ['Президиум', 'Суханова Светлана, Смертина Евгения, Малетина Александра, Курьянович Марина, Маркова Александра'],
  ['Тренинг-комитет', 'Суханова Светлана'],
  ['Этический комитет', 'Приходько Олеся'],
  ['Интервизионные группы', 'Малетина Александра'],
  ['Организационные вопросы', 'Коровина София, Семенова Анастасия, Рыбалова Татьяна'],
];

const memberGroups = [
  {
    title: 'Действительные члены АПП',
    members: [
      'Федоров Игорь Валерьевич',
      'Куринских Анастасия',
      'Малетина Александра',
      'Суханова Светлана',
      'Беккер Светлана',
      'Курьянович Марина',
      'Маркова Александра',
      'Корнева Марьяна',
      'Шевченко Ника',
    ],
  },
  {
    title: 'Ассоциированные члены АПП',
    members: ['Приходько Олеся', 'Рыбалова Татьяна', 'Юркин Даниил', 'Коровина София'],
  },
  {
    title: 'Наблюдательные члены АПП',
    members: [
      'Бакулина Диана',
      'Рах Николь',
      'Черешнева Ольга',
      'Шубина Ирина',
      'Барановский Олег',
      'Пермякова Кристина',
      'Кавун Олеся',
      'Плеханова Екатерина',
      'Смирнов Евгений',
      'Смертина Евгения',
      'Ватрушкина Анастасия',
      'Колпакова Маргарита',
      'Большакова Ангелина',
      'Алайцева Виктория',
    ],
  },
  {
    title: 'Кандидаты',
    members: [
      'Джимов Максим',
      'Мельничук Андрей',
      'Дужнова Анастасия',
      'Лебединская Светлана',
      'Лисота Дарья',
      'Зиновьева Виктория',
      'Федотов Денис',
      'Сумцова Мария',
      'Ловягин Кирилл',
      'Капитонова Елена',
      'Мизонова Татьяна',
      'Шульмина Снежана',
      'Кулешова Анастасия',
      'Чернецова Юлия',
      'Цой Лидия',
      'Колушева Екатерина',
    ],
  },
];

const principles = [
  [
    '01',
    'Профессиональная компетентность',
    'Работать только в пределах своей квалификации и постоянно развивать профессиональные навыки.',
  ],
  [
    '02',
    'Уважение личности',
    'Уважать ценности клиента и не допускать дискриминации.',
  ],
  [
    '03',
    'Информированное согласие',
    'Заранее объяснять формат, стоимость, правила и границы психологической помощи.',
  ],
  [
    '04',
    'Конфиденциальность',
    'Сохранять информацию клиента в тайне, кроме предусмотренных законом и безопасностью исключений.',
  ],
  [
    '05',
    'Честность',
    'Открыто говорить о своей квалификации, опыте и профессиональных возможностях.',
  ],
  [
    '06',
    'Запрет на эксплуатацию',
    'Не использовать профессиональные отношения с клиентом для личной выгоды.',
  ],
  [
    '07',
    'Ответственность сообщества',
    'Следить за профессиональной пригодностью и обращаться за супервизией при необходимости.',
  ],
];

const friends = [
  {
    name: 'Лукьянов Олег Валерьевич',
    photo: '/images/friend2.jpg',
    text: [
      'Доктор психологических наук, профессор, заведующий кафедрой психологии личности ФП ТГУ.',
      'Заместитель директора по научно-методической работе с вменением обязанностей преподавателя в Сибирском институте феноменологической и экзистенциальной психологии (СИФЭП).',
    ],
    link: 'https://sifep.ru',
    linkLabel: 'СИФЭП',
  },
  {
    name: 'Лявас Коварскис (Levas Kovarskis), Финляндия',
    photo: '/images/lavas.png',
    text: [
      'Почетный профессор и научный руководитель факультета психоанализа НОЧУ ВО «Московский институт психоанализа».',
      'Доктор медицины, психиатр, психоаналитик, старший член Финского психоаналитического общества (IPA), супервизор, автор обучающих программ в Финляндии, Литве и России.',
    ],
  },
  {
    name: 'Карась Екатерина Валериевна',
    photo: '/images/karas.jpg',
    text: [
      'Врач психотерапевт, стаж 20 лет.',
      'Ведет консультативный прием и проводит индивидуальную психотерапию. В психотерапевтической работе специализируется на когнитивно-поведенческой и рациональной психотерапии. Специалист в области оценки когнитивных функций в пожилом возрасте и оценке по шкале деменции (CDR).',
    ],
  },
  {
    name: 'Курьянович Марина',
    photo: '/images/marinaK.jpg',
    text: [
      'Дипломированный клинический психолог (СибГМУ) и сертифицированный гештальт-терапевт (МИГиП).',
    ],
    link: 'https://t.me/marinastoboi',
    linkLabel: 'Telegram',
  },
];

const gallery = [
  '/images/about-slider1.jpg',
  '/images/about-slider2.jpg',
  '/images/about-slider3.jpg',
  '/images/about-slider4.jpg',
  '/images/about-slider5.jpg',
];

function About() {
  const membersSliderRef = useRef(null);

const scrollMembers = (direction) => {
  if (!membersSliderRef.current) return;

  const slider = membersSliderRef.current;

  slider.scrollBy({
    left: direction * slider.clientWidth,
    behavior: 'smooth',
  });
};
  
  const historySliderRef = useRef(null);

const scrollHistory = (direction) => {
  if (!historySliderRef.current) return;

  const slider = historySliderRef.current;

  slider.scrollBy({
    left: direction * slider.clientWidth,
    behavior: 'smooth',
  });
};
  
  return (
    <main className="about-page">

      <section className="about-hero">
  <div className="app-container about-hero__inner">
    <div className="about-hero__title">

      <h1>
        Ассоциация практикующих психологов
      </h1>
    </div>

    <div className="about-hero__description">
      <p>
        Профессиональное сообщество, в котором психологи развиваются через практику,
        этическую ответственность, поддержку коллег и профессиональный диалог.
      </p>
    </div>
  </div>
</section>

   


  <section className="about-section" id="story">
  <div className="app-container">
    <div className="about-heading about-heading--compact">
      <div>
        <h2>История Ассоциации</h2>
      </div>
    </div>

    <div
      className="about-history-slider__viewport"
      ref={historySliderRef}
    >
      <div className="about-history-slider__track">
        {[
          '/images/about/history-slide-1.png',
          '/images/about/history-slide-2.png',
          '/images/about/history-slide-3.png',
          '/images/about/history-slide-4.png',
          '/images/about/history-slide-5.png',
          '/images/about/history-slide-6.png',
        ].map((src, index) => (
          <div className="about-history-slide" key={src}>
            <img
              src={`${process.env.PUBLIC_URL}${src}`}
              alt={`История Ассоциации — слайд ${index + 1}`}
            />
          </div>
        ))}
      </div>
    </div>
    <div className="about-slider-hint">
  
  <span className="about-slider-hint__arrows">← →</span>
</div>

    <div className="about-slider-controls">
      <button
        type="button"
        onClick={() => scrollHistory(-1)}
        aria-label="Предыдущий слайд"
      >
        <span aria-hidden="true">←</span>
      </button>

      <button
        type="button"
        onClick={() => scrollHistory(1)}
        aria-label="Следующий слайд"
      >
        <span aria-hidden="true">→</span>
      </button>
    </div>
  </div>
</section>

     <section className="about-section about-section--soft" id="people">
  <div className="app-container">
    <div className="about-heading">
      <div>
        <h2>Команда Ассоциации</h2>
      </div>

      <p>
        Президиум, профильные комитеты и специалисты, которые отвечают
        за профессиональные направления АПП.
      </p>
    </div>

    <div className="about-leadership">
      {leadership.map(([role, name]) => (
        <div className="about-leadership__row" key={role}>
          <span>{role}</span>
          <strong>{name}</strong>
        </div>
      ))}
    </div>

    <div className="about-birthday">
      <span>День рождения Ассоциации</span>
      <strong>05 мая 2025</strong>
    </div>
  </div>
</section>


      <section className="about-section" id="members">
  <div className="app-container">
    <div className="about-heading about-heading--compact">
      <div>
        <h2>Члены АПП</h2>
      </div>
    </div>

    <div
      className="about-members-slider__viewport"
      ref={membersSliderRef}
    >
      <div className="about-members-slider__track">
        {memberGroups.map((group, index) => (
          <article
            className="about-members-slide"
            key={group.title}
          >
            <div className="about-members-slide__header">
              <div>
                <span className="about-members-slide__number">
                  {String(index + 1).padStart(2, '0')}
                </span>

                <h3>{group.title}</h3>
              </div>

              <span className="about-members-slide__count">
                {group.members.length}
              </span>
            </div>

            <div className="about-members-slide__grid">
              {group.members.map((member) => (
                <div
                  className="about-members-slide__person"
                  key={member}
                >
                  {member}
                </div>
              ))}
            </div>
          </article>
        ))}
      </div>
    </div>

    <div className="about-slider-hint">
  <span className="about-slider-hint__arrows">← →</span>
</div>

    <div className="about-slider-controls">
      <button
        type="button"
        onClick={() => scrollMembers(-1)}
        aria-label="Предыдущая категория"
      >
        <span aria-hidden="true">←</span>
      </button>

      <button
        type="button"
        onClick={() => scrollMembers(1)}
        aria-label="Следующая категория"
      >
        <span aria-hidden="true">→</span>
      </button>
    </div>
  </div>
</section>

    <section className="about-section about-section--soft" id="ethics">
  <div className="app-container">

    <div className="about-heading about-heading--compact">
      <div>
        <h2>Этический кодекс</h2>
      </div>
    </div>


    {/* Главные действия */}
    <div className="about-ethics-actions">

      <div className="about-ethics-actions__text">
        <h3>Профессиональная этика — основа работы АПП</h3>

        <p>
          Кодекс определяет ключевые принципы профессиональной работы
          и принят всеми членами Ассоциации.
        </p>
      </div>


      <div className="about-ethics-actions__buttons">

        <a
          className="about-ethics-action about-ethics-action--primary"
          href="https://www.buildin.ai/form/49a3f19f-a4f0-406b-bc1f-e0e297c9f08b?code=GC2JSA"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>
            <small>Этический комитет</small>
            Подать обращение
          </span>

          <strong>→</strong>
        </a>


        <a
          className="about-ethics-action about-ethics-action--secondary"
          href={`${process.env.PUBLIC_URL}/ethics-codex-app.pdf`}
          download="Этический_кодекс_АПП.pdf"
        >
          <span>
            <small>Полный документ</small>
            Скачать кодекс PDF
          </span>

          <strong>↓</strong>
        </a>

      </div>
    </div>


    {/* Принципы */}
    
    {/* Принципы */}
<div className="about-principles-heading">
  <h3>Наши принципы</h3>
</div>

<div className="about-principles">
  {principles.map(([number, title, text]) => (
    <article className="about-principle" key={number}>
      <span className="about-principle__number">
        {number}
      </span>

      <div>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </article>
  ))}
</div>

  </div>
</section>

<section className="about-section" id="friends">
  <div className="app-container">
    <div className="about-heading">
      <div>
        <h2>Наши друзья</h2>
      </div>

      <p>
        Коллеги и специалисты, с которыми Ассоциацию объединяют
        профессиональные интересы и образовательные проекты.
      </p>
    </div>

    <div className="about-friends">
      {friends.map((friend) => (
        <article className="about-friend" key={friend.name}>
          <div className="about-friend__photo">
            <img
              src={`${process.env.PUBLIC_URL}${friend.photo}`}
              alt={friend.name}
            />
          </div>

          <div className="about-friend__content">
            <h3>{friend.name}</h3>

            {friend.text.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}

            {friend.link && (
              <a
                href={friend.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {friend.linkLabel} ↗
              </a>
            )}
          </div>
        </article>
      ))}
    </div>
  </div>
</section>

      <section className="about-section about-section--soft" id="life">
  <div className="app-container">
    <div className="about-heading">
      <div>
        <h2>Моменты из нашей жизни</h2>
      </div>

      <p>
        Встречи, события и моменты, которые становятся частью жизни Ассоциации.
      </p>
    </div>

    <div className="about-gallery">
      {gallery.map((src, index) => (
        <figure
          className={`about-gallery__item about-gallery__item--${index + 1}`}
          key={src}
        >
          <img
            src={`${process.env.PUBLIC_URL}${src}`}
            alt={`Момент из жизни Ассоциации ${index + 1}`}
          />
        </figure>
      ))}
    </div>
  </div>
</section>

<section className="about-home-link">
  <div className="app-container">
    <div className="about-home-link__inner">
      <Link to="/" className="about-home-link__button">
        На главную
      </Link>
    </div>
  </div>
</section>

    </main>
  );
}

export default About;

